<template>
  <div class="studyTask-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            公告管理
            <el-button size="small" icon="el-icon-circle-plus-outline" @click="editRow(null)" style="margin-left: 70px" type="text">添加公告</el-button>
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="searchNotice" placeholder="搜索公告" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="searchNotice"/>
            </div>
          </div>
          <div class="card-content" >
            <el-row>
              <el-col :span="5">
                <ul class="task-filter">
                  <li :class="typeId===''?'active':''" @click="change('')">全部公告</li>
                  <li v-for="category in noticeCategoryData" :class="typeId===category.ntid?'active':''" @click="change(category.ntid)">{{category.name}}</li>
                </ul>
              </el-col>
              <el-col :span="19" v-loading="loading">
                <el-table
                  :data="noticeData"
                  :row-style="{cursor: 'pointer'}"
                  :show-header="false"
                  @row-click="getNotice"
                  style="width: 100%">
                  <el-table-column
                    label="公告标题"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag size="mini" v-if="scope.row.see===0">公开</el-tag>
                      <el-tag type="success" size="mini" v-if="scope.row.see===1">组织</el-tag>
                      <el-tag type="danger" size="mini" v-if="scope.row.see===2">经销商</el-tag>
                      <span>【{{scope.row.type_name}}】{{scope.row.notice_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="170"
                    class-name="deadline"
                    label="发布部门">
                    <template slot-scope="scope">
                      <span>{{scope.row.dept_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="发布时间"
                    width="200">
                    <template slot-scope="scope">
                      <span class="deadline">{{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="180">
                    <template slot-scope="scope">
                      <el-button @click.stop="editRow(scope.row)" size="mini" type="primary" icon="el-icon-edit-outline">修改</el-button>
                      <el-button @click.stop="deleteRow(scope.row)" size="mini" type="danger" icon="el-icon-delete">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editData.noticeId!==0?'编辑公告':'添加公告'"
      :visible.sync="dialogVisible"
      width="60%"
      top="8vh"
      :lock-scroll="true"
      :append-to-body="true"
      :destroy-on-close="true"
      :before-close="handleClose">
        <el-form ref="editData" size="small" v-loading="editData.loading" :rules="formRules" :model="editData" label-width="100px">
          <el-form-item label="可见性" prop="see">
            <el-radio-group v-model="editData.see">
              <el-radio :label="0">公开</el-radio>
              <el-radio :label="1">仅组织可见</el-radio>
              <el-radio :label="2">仅经销商可见</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="editData.title" />
          </el-form-item>
          <el-form-item label="公告分类" prop="category">
            <el-select v-model="editData.category" placeholder="请选择公告分类">
              <el-option v-for="item in noticeCategoryData" :label="item.name" :key="item.ntid" :value="item.ntid"/>
            </el-select>
          </el-form-item>
          <el-form-item label="是否置顶" prop="isTop">
            <el-radio-group v-model="editData.isTop">
              <el-radio :label="1">置顶</el-radio>
              <el-radio :label="0">不置顶</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否发布" prop="isSub">
            <el-radio-group v-model="editData.isSub">
              <el-radio :label="1">发布</el-radio>
              <el-radio :label="0">不发布</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="公告内容" prop="content">
            <tinymce ref="tinymce" :key="editData.key" v-model="editData.content" :height="200"/>
          </el-form-item>
          <el-form-item label="上传附件" prop="files">
            <MultiFile :key="editData.key" v-model="editData.files" :old="oldFile"/>
          </el-form-item>
          <el-form-item>
            <el-button :loading="btnLoading" type="primary" @click="subNotice('editData')">立即提交</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { getUser } from '@/utils/auth'
  import { getNoticeCategory } from '@/api/home'
  import { getNoticeList } from '@/api/home'
  import MultiImg from '@/components/upload/MultiImg'
  import MultiFile from '@/components/upload/MultiFile'
  import tinymce from '@/components/Tinymce'
  import { getNoticeDetail } from '@/api/home'
  import { addOrEditNotice } from '@/api/work'
  import { deleteNotice } from '@/api/work'

  export default {
    components: { MultiFile, MultiImg,tinymce },

    name: 'notice_list',
    data(){
      return {
        btnLoading: false,
        dialogVisible: false,
        noticeData:[],
        sort: 0 ,
        pageSize: 20,
        currentPage: 1,
        total: 0,
        typeId: '',
        noticeCategoryData:[],
        search: '',
        loading: false,
        oldFile: [],
        editData: {
          key: '',
          loading: false,
          see: 0,
          noticeId: '',
          title: '',
          content: '',
          category: '',
          isTop: '',
          isSub: '',
          files: []
        },
        formRules: {
          see:[
            {required: true, message: '请选择可见性', trigger: 'change' }
          ],
          title:[
            {required: true, message: '请输入公告标题', trigger: 'blur' },
          ],
          category:[
            {required: true, message: '请选择公告分类', trigger: ['change','blur'] },
          ],
          isSub: [
            {required: true, message: '请选择是否发布', trigger: 'change' },
          ],
          isTop: [
            {required: true, message: '请选择是否置顶', trigger: 'change' },
          ],
          content: [
            {required: true, message: '请输入公告内容', trigger: 'blur' },
          ]
        }
      }
    },
    computed:{
      user: getUser
    },
    created() {
      this.getNoticeData()
      this.getNoticeCategory()
    },
    methods:{
      getNoticeData() {
        const _this = this
        const data = {
          page: _this.currentPage,
          limit: _this.pageSize,
          typeId: _this.typeId,
          userid: _this.user.dUserid,
          role: 0,
          content: _this.search,
          mark: 1,
          isAdmin: 1
        }
        _this.loading = true

        getNoticeList(data).then(response => {
          _this.noticeData = response.data.list
          _this.total = response.data.total
          _this.loading = false
        })
      },
      getNoticeCategory(){
        const _this = this
        getNoticeCategory().then(response=>{
          _this.noticeCategoryData = response.data
        })
      },
      change(sort){
        this.typeId = sort
        this.getNoticeData()
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.currentPage = 1
        this.getNoticeData()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getNoticeData()
      },
      searchNotice(){
        this.currentPage = 1
        this.getNoticeData()
      },
      getNotice(row){
        this.$router.push({ path: '/notice/notice_detail/'+row.notice_id })
      },
      editRow(row){
        this.dialogVisible = true
        this.editData.loading = true
        if(row!=null){
          this.editData.noticeId = row.notice_id
          this.oldFile = []
          getNoticeDetail({noticeId: row.notice_id}).then(response=>{
            this.editData.content = response.data.content
            this.editData.title = response.data.title
            this.editData.isSub = response.data.mark
            this.editData.isTop = response.data.istop
            this.editData.see = response.data.see
            this.editData.category = response.data.ntid
            if(response.data.noticeAnnexList.length>0){
              for(let i = 0;i<response.data.noticeAnnexList.length;i++){
                let file = {
                  name: response.data.noticeAnnexList[i].filename,
                  id: response.data.noticeAnnexList[i].fileid
                }
                this.oldFile.push(file)
              }
            }
          })
        } else {
          this.editData.noticeId = 0
          this.editData.title = ''
          this.editData.category = ''
          this.editData.isTop = ''
          this.editData.isSub = ''
          this.editData.see = 0
          this.oldFile = []
        }
        this.editData.key = new Date().getTime().toString()
        this.editData.loading = false
        /*this.$refs['tinymce'].setContent(this.editData.content)*/
      },
      deleteRow(row){
        this.$confirm('您确定将这条公告删除吗？', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          deleteNotice({noticeId: row.notice_id}).then(response=>{
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getNoticeData()
          })
        }).catch(() => {
        });
      },
      handleClose(done){
        this.$refs['tinymce'].setContent('')
        this.editData.title = ''
        this.editData.category = ''
        this.editData.isTop = ''
        this.editData.isSub = ''
        this.editData.noticeId = 0
        this.editData.see = 0
        this.oldFile = []
        done();
      },
      subNotice(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            const data = {
              groupId: this.user.dGroupid,
              deptId: this.user.dDeptid,
              see: this.editData.see,
              title: this.editData.title,
              content: this.editData.content,
              fileStr: this.editData.files.toString(),
              type: this.editData.category,
              isTop: this.editData.isTop,
              isSub: this.editData.isSub,
              noticeId: this.editData.noticeId
            }
            addOrEditNotice(data).then(response=>{
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              this.btnLoading = false
              this.dialogVisible = false
              this.getNoticeData()
            }).catch(() => {
              this.btnLoading = false
            });
          }
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .studyTask-container {
    .tcf-row {
      .card {
        .card-body {
          .card-title {
            .study-leader {
              color: #f3ad49;
              font-weight: 500;
            }
          }

          .card-content {
            .task-filter {
              width: 100%;
              padding: 0 30px 0 0;
              margin: 10px 0 0 0;
              position: relative;

              li {
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;

                &.active {
                  background: #f5f7fa;
                  color: #409EFF;
                }

                &:hover {
                  color: #409EFF;
                }
              }
            }

            .el-table::before {
              height: 0 !important;
            }

            .el-pagination {
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
  .search-mode{
    float: right;
    width: 300px;
    .search-input{
      background-color: #F2F6FC;
      border:0;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      color: #606266;
      padding: 0 40px 0 15px;
      -webkit-appearance: none;
      font-size: 12px;
      width: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      &::-webkit-input-placeholder {
        color: #C0C4CC;
      }
      &::-ms-input-placeholder {
        color: #C0C4CC;
      }
    }
    .search-btn{
      position: absolute;
      right: 0;
      height: 32px;
      width: 40px;
      line-height: 32px;
      top: 0;
      border: 0;
      background: transparent;
      text-align: center;
      padding: 0;
    }
  }

</style>
